import { useTranslation } from 'react-i18next';
import { Input, Select } from '@artosera/ui';
import type { AuteurEstimation } from '@artosera/shared';
import { Field } from '../Field.js';

export function AuteurEstimationChamps({
  auteur,
  compteId,
  onChange,
}: {
  auteur: AuteurEstimation;
  compteId: string;
  onChange: (auteur: AuteurEstimation) => void;
}) {
  const { t } = useTranslation('regie');
  return (
    <>
      <Field htmlFor="assurance-auteur" label={t('assurance.auteur')}>
        <Select
          id="assurance-auteur"
          value={auteur.type}
          onValueChange={(type) => {
            if (type === 'membre') onChange({ type, compteId });
            else if (type === 'expert' || type === 'maison_de_ventes') onChange({ type, nom: '' });
          }}
          options={['membre', 'expert', 'maison_de_ventes'].map((type) => ({
            value: type,
            label: t(`assurance.auteurs.${type}`),
          }))}
        />
      </Field>
      {auteur.type !== 'membre' && (
        <Field htmlFor="assurance-auteur-nom" label={t('assurance.nomAuteur')}>
          <Input
            id="assurance-auteur-nom"
            required
            maxLength={200}
            value={auteur.nom}
            onChange={(e) => onChange({ ...auteur, nom: e.target.value })}
          />
        </Field>
      )}
    </>
  );
}
